<div class="container apr-landing">
  <div *ngIf="loading" class="text-muted">Loading your tasks…</div>

  <ng-container *ngIf="!loading">
    <p *ngIf="loadError" class="apr-landing__error text-danger">
      Couldn't load your tasks — refresh the page to try again.
    </p>

    <ng-container *ngIf="!loadError">
      <p *ngIf="isEmpty" class="apr-landing__empty">{{ emptyMessage }}</p>

      <ul *ngIf="!isEmpty" class="apr-landing__lines list-unstyled">
        <li *ngFor="let line of summaryLines; trackBy: trackByKey" class="apr-landing__line">
          <a *ngIf="line.routerLink; else plain" [routerLink]="line.routerLink">{{ line.text }}</a>
          <ng-template #plain>{{ line.text }}</ng-template>
        </li>
      </ul>
    </ng-container>
  </ng-container>
</div>
